/* @ngInject */
function AssetPreviewNavigationController ($rootScope, $scope, $timeout, $q, AssetPreviewService, ModalService) {
  $scope.currentAssetIndex = 0
  $scope.nextAssetsCount = 0
  $scope.previousAssetsCount = 0
  $scope.totalAssetsCount = 0
  $scope.assets = []
  $scope.rotatedAssets = []
  $scope.navigationAssets = []

  $scope.navigationTop = 6
  $scope.navigationNextSkip = 0

  const api = {
    _handleKeyboardNavigation,
    _handleGetAssets,
    _setCurrentAsset,
    _setNavigationAssets,
    _rotateArray,
    _shouldGetMorePreviousAssets,
    _shouldGetMoreNextAssets,
    _getNavigationRightSkip,
    _getCurrentAssetIndex,
    _removeObjectsByAssetId,
    _checkKeyboardNavigationAvailability
  }
  this.getApi = () => api

  activate()

  function activate () {
    if (!$scope.getPreviewAssets) {
      return
    }

    $q.all([
      $scope.getPreviewAssets($scope.currentAsset.artCollectionId, 10, 0, $scope.currentAsset.id, 'next'),
      $scope.getPreviewAssets($scope.currentAsset.artCollectionId, 10, 0, $scope.currentAsset.id, 'previous')
    ]).then(res => {
      $scope.nextAssetsCount = res[0].count
      $scope.previousAssetsCount = res[1].count
      $scope.totalAssetsCount = $scope.nextAssetsCount + $scope.previousAssetsCount - 1
      $scope.navigationTop = $scope.totalAssetsCount >= 6 ? 6 : $scope.totalAssetsCount

      if ($scope.nextAssetsCount <= 0) {

      } else if ($scope.nextAssetsCount < 6) {
        $scope.getPreviewAssets($scope.currentAsset.artCollectionId, 10, 0, null, null).then(newRes => {
          api._handleGetAssets([...newRes.assets, ...res[0].assets, ...res[1].assets])
          $scope.currentAssetIndex = api._getCurrentAssetIndex()
          api._setNavigationAssets()
        })
      } else {
        api._handleGetAssets([...res[0].assets, ...res[1].assets])
        $scope.currentAssetIndex = api._getCurrentAssetIndex()
        api._setNavigationAssets()
      }
    })

    document.addEventListener('keydown', api._handleKeyboardNavigation)
  }

  const deregisterDeleteAsset = $rootScope.$on('onDeleteAsset', (_, { assetId, shouldClose, shouldOpenComments }) => {
    const isManyAssets = $scope.assets.length > 1
    const isNotManyAssets = !isManyAssets

    if (isNotManyAssets && shouldOpenComments) {
      $rootScope.$emit('asset-preview.open-comments')
      $rootScope.$emit('asset-preview.approvalButtons.hide')
    }

    if (isManyAssets) {
      return $scope.deleteAssetFromNavigation(assetId)
    }

    if (shouldClose) {
      $rootScope.$emit('asset-preview.close')
    }
  })

  $scope.$on('$destroy', () => {
    document.removeEventListener('keydown', api._handleKeyboardNavigation)
    deregisterDeleteAsset()
  })

  $scope.deleteAssetFromNavigation = assetId => {
    $timeout(() => {
      const newAssets = api._removeObjectsByAssetId($scope.assets, assetId)
      $scope.assets = []
      api._handleGetAssets(newAssets)
      api._setNavigationAssets()
      api._setCurrentAsset()
    })
  }

  function _removeObjectsByAssetId (array, assetIdToRemove) {
    return array.filter(item => {
      const isAssetIdToKeep = item.assetId && item.assetId !== assetIdToRemove
      const isArtIdToKeep = item.id && item.id !== assetIdToRemove

      if (isAssetIdToKeep) return item

      if (isArtIdToKeep) return item
    })
  }

  function _handleKeyboardNavigation (ev) {
    const isArrowLeft = ev.code === 'ArrowLeft' && ev.which === 37
    const isArrowRigth = ev.code === 'ArrowRight' && ev.which === 39
    const focusedElement = ev.target

    const isNavigationBlocked = api._checkKeyboardNavigationAvailability(focusedElement)

    if (!isNavigationBlocked) {
      if (isArrowLeft && $scope.navigationAssets.length > 1) {
        $scope.navigateLeft()
      }

      if (isArrowRigth && $scope.navigationAssets.length > 1) {
        $scope.navigateRight()
      }
    }
  }

  function _checkKeyboardNavigationAvailability (focusedElement) {
    const focusedElementTag = focusedElement.tagName.toLowerCase()
    const elementsToIgnore = ['uds-text-area', 'trix-editor']
    if (elementsToIgnore.includes(focusedElementTag)) return true
    if (focusedElement.classList.contains('ql-editor')) return true

    const isModalOpen = ModalService.getCurrentModal()

    if (isModalOpen) {
      const openedModalZIndex = getComputedStyle(isModalOpen.element[0])?.zIndex
      const assetPreviewDialogZIndex = $('.asset-preview-dialog').css('z-index')

      const isOpenedModalBehindPreview = Number(openedModalZIndex) < Number(assetPreviewDialogZIndex)

      return isModalOpen && !isOpenedModalBehindPreview
    }
  }

  function _handleGetAssets (assets) {
    $scope.assets = [...assets, ...$scope.assets].reduce((arr, asset) => {
      const assetIsInArray = arr.find(item => item.id === asset.id)

      if (!assetIsInArray) {
        arr.push(asset)
      }

      return arr
    }, [])
    $scope.assets.sort((a, b) => a.order - b.order)
  }

  function _setNavigationAssets () {
    $timeout(
      () => {
        $scope.rotatedAssets = api._rotateArray($scope.assets, $scope.currentAssetIndex)
        $scope.navigationAssets = $scope.rotatedAssets.slice(null, $scope.navigationTop)
      },
      0,
      true
    )
  }

  function _setCurrentAsset () {
    $timeout(
      () => {
        $scope.currentAsset = $scope.rotatedAssets[0]
      },
      0,
      true
    )
  }

  function _rotateArray (array, count) {
    var len = array.length >>> 0
    count = count >> 0
    const arr = array.slice()

    arr.unshift.apply(arr, arr.splice.call(arr, count % len, len)) // eslint-disable-line
    return arr
  }

  $scope.navigateRight = () => {
    if (api._shouldGetMoreNextAssets()) {
      $scope.navigationNextSkip = api._getNavigationRightSkip()
      $scope
        .getPreviewAssets($scope.currentAsset.artCollectionId, 10, $scope.navigationNextSkip, null, null)
        .then(res => {
          api._handleGetAssets(res.assets)
          $scope.currentAssetIndex = api._getCurrentAssetIndex() + 1
          api._setNavigationAssets()
          api._setCurrentAsset()
        })
    } else {
      $scope.currentAssetIndex = $scope.currentAssetIndex + 1
      api._setNavigationAssets()
      api._setCurrentAsset()
    }

    if ($scope.nextAssetsCount <= 1) {
      const oldPreviousAssetsCount = $scope.previousAssetsCount
      $scope.previousAssetsCount = $scope.nextAssetsCount
      $scope.nextAssetsCount = oldPreviousAssetsCount
    } else {
      $scope.nextAssetsCount = $scope.nextAssetsCount - 1
      $scope.previousAssetsCount = $scope.previousAssetsCount + 1
    }
  }

  function _getCurrentAssetIndex () {
    return $scope.assets.findIndex(asset => asset.id === $scope.currentAsset.id)
  }

  function _shouldGetMoreNextAssets () {
    const lastNavigationAsset = $scope.navigationAssets[$scope.navigationAssets.length - 1]
    const currentAssetIndexNotRotated = $scope.assets.findIndex(asset => asset.id === lastNavigationAsset.id)

    if (currentAssetIndexNotRotated === $scope.assets.length - 1 && $scope.assets.length < $scope.totalAssetsCount) {
      return true
    } else {
      return false
    }
  }

  function _getNavigationRightSkip () {
    const assetsToLoad = 9
    if ($scope.nextAssetsCount <= 6) {
      return 0
    }
    return $scope.navigationNextSkip + assetsToLoad
  }

  $scope.navigateLeft = () => {
    if (api._shouldGetMorePreviousAssets()) {
      const assetsToLoad = 9
      const skip = $scope.totalAssetsCount - $scope.previousAssetsCount - assetsToLoad

      $scope.getPreviewAssets($scope.currentAsset.artCollectionId, 10, skip, null, null).then(res => {
        $scope.currentAssetIndex = $scope.currentAssetIndex - 1
        api._handleGetAssets(res.assets)
        api._setNavigationAssets()
        api._setCurrentAsset()
      })
    } else {
      $scope.currentAssetIndex = $scope.currentAssetIndex - 1
      api._setNavigationAssets()
      api._setCurrentAsset()
    }

    if ($scope.previousAssetsCount <= 1) {
      const oldNextAssetsCount = $scope.nextAssetsCount
      $scope.nextAssetsCount = $scope.previousAssetsCount
      $scope.previousAssetsCount = oldNextAssetsCount
    } else {
      $scope.nextAssetsCount = $scope.nextAssetsCount + 1
      $scope.previousAssetsCount = $scope.previousAssetsCount - 1
    }
  }

  function _shouldGetMorePreviousAssets () {
    const firstAssetOrder = $scope.rotatedAssets[0].order
    const lastAssetOrder = $scope.rotatedAssets[$scope.rotatedAssets.length - 1].order

    if (Math.abs(firstAssetOrder - lastAssetOrder) > 1 && $scope.assets.length < $scope.totalAssetsCount) {
      return true
    }

    return false
  }

  $scope.toggleButton = () => {
    $scope.previewFlags.navigationIsOpen = !$scope.previewFlags.navigationIsOpen
  }

  $scope.getAssetThumbnail = asset => {
    const isTemplate = !asset.assetId || asset.assetId !== asset.id

    if (isTemplate) {
      return AssetPreviewService.getArtThumbnail(asset.id)
    } else {
      return AssetPreviewService.getAssetThumbnail(asset.id)
    }
  }

  $scope.onImgLoadError = () => {
    return '/assets/img/repository_asset_thumbs/file.png'
  }
}

export { AssetPreviewNavigationController }
